import React from 'react'
import { useTranslation } from 'react-i18next'
import { CustomButton, CouponContainer } from './mixins'
import { Props } from '../../interface'

export const ApplyCouponButton = ({ isInputVisible, setIsInputVisible }: Props) => {
  const { t } = useTranslation()
  const icon = { name: 'icon-bold-price-tag' }
  const buttonOptions = { size: 'small', type: 'link', block: 'true' }

  return (
    <CouponContainer>
      <CustomButton buttonoptions={buttonOptions} icon={icon} onClick={() => setIsInputVisible(!isInputVisible)}>
        {t('ecommerce.coupon.apply')}
      </CustomButton>
    </CouponContainer>
  )
}
